import { gql } from "@apollo/client";

export const BUILDING_LOTTERY_FIELDS_FRAGMENT = gql`
  fragment BuildingLotteryFieldsV2 on BuildingInterface {
    id
    slug
    url
    accessibilityDetails
    hasAccessibleUnits
    amenities
    moveInRequirements
    images {
      id
      accessibilityFeatures
    }
    availability {
      status
      bedrooms
      units {
        id
        deleted
        unitType
        unitCount
        fcfsUnitCount
        fcfsUnitCount
        bathroomCount
        mobilityAccessible
        visionAccessible
        hearingAccessible
        rentType
        floating
        ami
        minIncome
        rentalCost
        isAffordable
        maxIncomes {
          id
          householdSize
          maxIncome
        }
      }
    }
    housingLottery {
      id
      applicantAccommodations
      contactEmail
      contactName
      contactPhone
      details
      endDate
      infoSession1Datetime
      infoSession2Datetime
      infoSessionDetails
      infoSessionUrl
      ownContactInfo
      notifyPropertyContact
      startDate
      url
      waitlistStatus
      documents {
        id
        name
        category
        fileUrl
        filename
        extension
        __typename
      }
      __typename
    }
    hasPreferences
    preferences {
      id
      kind
      condition
      details
    }
    __typename
  }
`;

export default BUILDING_LOTTERY_FIELDS_FRAGMENT;
